import { lazy, Suspense } from "react";
import { profitDashboardMode } from "./profit-dashboard-config";

const BasicProfitDashboard = lazy(() => import("./components/BasicProfitDashboard"));
const LegacyProfitDashboard = lazy(() => import("./components/LegacyProfitDashboard"));

const AgentProfitDashboard = lazy(() => import('./components/AgentProfitDashboard'));

export default function ProfitDashboardPage() {
  const Page = profitDashboardMode === "agent" ? AgentProfitDashboard : profitDashboardMode === "basic" ? BasicProfitDashboard : LegacyProfitDashboard;
  return <Suspense fallback={<p role="status">加载盈利大盘...</p>}><Page /></Suspense>;
}
